<template>
  <div class="card" v-if="statistics">
    <div class="card--content">
      <div class="card--number">
        <div class="card--number-value">
          {{leadsCount}}
        </div>
        <div class="card--number-key">
          {{$t('statistics.leads')}}
        </div>
      </div>
      <hr>
      <div class="card--diagram">
        <div class="grid classification">
          <div class="hot">
            <span class="value">{{leadsHotCount}}</span>
            {{$t('statistics.leads_hot')}}
          </div>
          <div class="warm">
            <span class="value">{{leadsWarmCount}}</span>
            {{$t('statistics.leads_warm')}}
          </div>
          <div class="cold">
            <span class="value">{{leadsColdCount}}</span>
            {{$t('statistics.leads_cold')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DonutChart from '@/components/helpers/DataDisplay/DonutChart'

export default {
  name: 'leads-classification',
  components: {DonutChart},
  props: ['statistics'],
  computed: {
    leadsCount(){
      return this.statistics.leads_count
    },
    leadsColdCount(){
      return this.statistics.cold_leads_count
    },
    leadsWarmCount(){
      return this.statistics.warm_leads_count
    },
    leadsHotCount(){
      return this.statistics.hot_leads_count
    },
    classificationSeries(){
      return [ this.leadsHotCount, this.leadsWarmCount, this.leadsColdCount ]
    }
  }
}
</script>
<style lang="scss" scoped>
.classification.grid{
  text-align: center;
  color: #989898;
  .hot{
    .value{color: $lead-hot;}
  }
  .warm{
    .value{color: $lead-warm;}
  }
  .cold{
    .value{color: $lead-cold;}
  }
  .value{
    font-size: 22px;
    vertical-align: sub;
    font-weight: 400;
  }
  @include respond-to("small") {
    >div{
      margin: 0 10px;
    }
  }
}


</style>
<style lang="scss">
.card--diagram{
  .donut-chart{
    margin-bottom: 20px;
    height: 200px;
    margin-top: 15px;
  }
  .ct-label{
    fill: #fff;
    font-weight: 800;
  }
  .ct-series:nth-child(1) .ct-slice-donut-solid{
    fill: $lead-hot;
  }
  .ct-series:nth-child(2) .ct-slice-donut-solid{
    fill: $lead-warm;
  }
  .ct-series:nth-child(3) .ct-slice-donut-solid{
    fill: $lead-cold;
  }
}
</style>



// WEBPACK FOOTER //
// ProjectStatisticsLeadsClassification.vue?0e33d7b2